/* eslint-disable camelcase */
import { Client } from '@eql-ai/typescript-types';

export const SET_CLIENT = 'SET_CLIENT';
export const SET_OUTCOME_GOAL = 'SET_OUTCOME_GOAL';
export const SET_AUTO_MODE = 'SET_AUTO_MODE';
export const SET_PATIENT = 'SET_PATIENT';
export const RESET_SANDBOX = 'RESET_SANDBOX';
export const UPDATE_AUTO_STATUS = 'UPDATE_AUTO_STATUS';
export const SET_BODY_PART_NUM = 'SET_BODY_PART_NUM';
export const OPEN_TRANSCRIPT = 'OPEN_TRANSCRIPT';

export interface SandboxPatient {
    first_name: string;
    last_name: string;
    patient_id: string;
    referral_type: any;
    dob: string;
}

export interface SandboxState {
    client?: Client;
    patient: SandboxPatient;
    autoMode: boolean;
    outcomeGoal: string;
    playInAutoMode: boolean;
    autoBodyParts: number;
    openTranscript: boolean;
}

interface SetClient {
    type: typeof SET_CLIENT;
    payload: Client;
}

interface SetOutcomeGoal {
    type: typeof SET_OUTCOME_GOAL;
    payload: string;
}

interface SetAutoMode {
    type: typeof SET_AUTO_MODE;
    payload: boolean;
}

interface SetPatient {
    type: typeof SET_PATIENT;
    payload: SandboxPatient;
}

interface ResetSandbox {
    type: typeof RESET_SANDBOX;
}

interface UpdateAutoStatus {
    type: typeof UPDATE_AUTO_STATUS;
    payload: boolean;
}

interface SetNumOfBodyParts {
    type: typeof SET_BODY_PART_NUM;
    payload: number;
}

interface OpenTranscript {
    type: typeof OPEN_TRANSCRIPT;
    payload: boolean;
}

export type SandboxTypes =
    | SetClient
    | SetOutcomeGoal
    | SetAutoMode
    | SetPatient
    | ResetSandbox
    | UpdateAutoStatus
    | SetNumOfBodyParts
    | OpenTranscript;
